import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { IStoreLocatorMapProps } from './types';

const MapWrapper = Box.withConfig({
  backgroundColor: Styles.color.white,
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  justifyContent: 'center',
  height: {
    md: 'full',
  },
});

export const StoreLocatorMap = ({ map }: IStoreLocatorMapProps) => {
  return <MapWrapper testID="store-locator-map">{map}</MapWrapper>;
};
